<template>
    <div class="plus-button" @click="onClicked">
        <span class="icon" v-html="icons('plus')"></span>
        <span>{{ label }}</span>
    </div>
</template>

<script>
import icons from "../../icons";
export default {
    props: {
        label: String
    },
    data() {
        return {
            icons
        };
    },
    methods: {
        onClicked() {
            this.$emit("click");
        }
    }
};
</script>

<style lang="scss" scoped>
.plus-button {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #185af5;
    cursor: pointer;

    .icon {
        svg {
            width: 40px;
            height: 40px;
        }
    }
}
</style>
